export const PROPERTIES_JSON = () => {
  let host = window.location.hostname;
  const local = host.indexOf('localhost') !== -1;
  const queryCache = `?q=${new Date().getTime()}`;
  if (local) {
    return `https://www.antena3.com/elecciones-2021-cat-pre/elections.json${
      queryCache || ''
    }`;
  }
  if (process.env.REACT_APP_STAGING) {
    return `https://${
      window.location.hostname
    }/elecciones-2021-cat-pre/elections.json${queryCache || ''}`;
  }
  return `https://${
    window.location.hostname
  }/elecciones-2021-cat/elections.json${queryCache || ''}`;
};
